import "./style.css";
import Phaser from "phaser";
import { runAuthFlow } from "./ui/auth.js";
import { connectToWorld } from "./net/room.js";
import { HUD } from "./ui/hud.js";
import { WorldScene } from "./scenes/WorldScene.js";

const overlay = document.getElementById("overlay")!;

function showLoading(msg: string): HTMLElement {
  const el = document.createElement("div");
  el.className = "auth-screen";
  el.innerHTML = `<div class="auth-card"><h1 class="title">EMBER</h1><div class="loading">${msg}</div></div>`;
  overlay.appendChild(el);
  return el;
}

function showFatal(msg: string) {
  overlay.innerHTML = `<div class="auth-screen"><div class="auth-card">
    <h1 class="title">EMBER</h1>
    <div class="error">${msg}</div>
    <button class="btn" onclick="location.reload()">TRY AGAIN</button>
  </div></div>`;
}

async function main() {
  const characterId = await runAuthFlow(overlay);

  const loading = showLoading("Lighting the world…");
  let room;
  try {
    room = await connectToWorld(characterId);
  } catch (e) {
    loading.remove();
    showFatal(`Could not reach the world server. ${(e as Error).message}`);
    return;
  }
  loading.remove();

  const hud = new HUD(overlay, room);

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: "game",
    backgroundColor: "#11101a",
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: window.innerWidth,
      height: window.innerHeight,
    },
    render: { antialias: true, pixelArt: false, preserveDrawingBuffer: true },
    scene: [],
  });
  game.scene.add("world", WorldScene, true, { room, hud });
  (window as unknown as { __game: Phaser.Game; __room: typeof room }).__game = game;
  (window as unknown as { __game: Phaser.Game; __room: typeof room }).__room = room;

  room.onLeave((code) => {
    if (code === 1000) return; // normal close
    hud.system("⚠ Disconnected from the world. Reload to return.");
  });
  room.onError((_code, message) => hud.system(`Server error: ${message ?? "unknown"}`));
}

main().catch((e) => {
  console.error(e);
  showFatal((e as Error).message ?? "Something went wrong.");
});
